import React from 'react';
import { View, StyleSheet } from 'react-native';
import { TextInput, Text } from 'react-native-paper';
import { getLocales } from 'expo-localization';

export default function NumberTextInput(props) {
  const [data, setData] = React.useState('');
  const [value, setValue] = React.useState(props.value ? props.value : '');
  const deviceLanguage = getLocales(); 
  const languageCodes = deviceLanguage.map(item => item.languageCode);

  React.useEffect(() => {
    let text = props.defaultValue || props.value;
    if(text) {
      onChangeTextInput(text.toString().replace(",", ''));
    }
  }, []);

  // تابع تبدیل اعداد به حروف فارسی
  const convertToPersianWords = (number) => {
    if (!number || number === '' || number === '0') return '';
    
    const num = parseFloat(number);
    if (isNaN(num)) return '';

    const persianNumbers = ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'];
    const tens = ['', 'ده', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'];
    const hundreds = ['', 'صد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'];
    const scales = ['', 'هزار', 'میلیون', 'میلیارد', 'تریلیون'];

    const convertThreeDigit = (n) => {
      let result = '';
      const hundred = Math.floor(n / 100);
      const ten = Math.floor((n % 100) / 10);
      const one = n % 10;

      if (hundred > 0) {
        result += hundreds[hundred];
      }

      if (ten > 0) {
        if (result !== '') result += ' و ';
        if (ten === 1 && one > 0) {
          switch (one) {
            case 1: result += 'یازده'; break;
            case 2: result += 'دوازده'; break;
            case 3: result += 'سیزده'; break;
            case 4: result += 'چهارده'; break;
            case 5: result += 'پانزده'; break;
            case 6: result += 'شانزده'; break;
            case 7: result += 'هفده'; break;
            case 8: result += 'هجده'; break;
            case 9: result += 'نوزده'; break;
          }
          return result;
        } else {
          result += tens[ten];
        }
      }

      if (one > 0) {
        if (result !== '') result += ' و ';
        result += persianNumbers[one];
      }

      return result;
    };

    if (num === 0) return 'صفر';

    let words = '';
    let tempNum = Math.floor(num);
    let scaleIndex = 0;

    while (tempNum > 0) {
      const threeDigit = tempNum % 1000;
      if (threeDigit > 0) {
        let threeDigitWords = convertThreeDigit(threeDigit);
        if (scaleIndex > 0) {
          threeDigitWords += ' ' + scales[scaleIndex];
        }
        if (words !== '') {
          words = threeDigitWords + ' و ' + words;
        } else {
          words = threeDigitWords;
        }
      }
      tempNum = Math.floor(tempNum / 1000);
      scaleIndex++;
    }

    // اضافه کردن قسمت اعشاری اگر وجود دارد
    const decimalPart = (num - Math.floor(num)).toFixed(2).split('.')[1];
    if (decimalPart && parseInt(decimalPart) > 0) {
      words += ' ممیز ';
      const decimalWords = convertThreeDigit(parseInt(decimalPart));
      words += decimalWords;
    }

    return words;
  };

  const numberWithComma = x => {
    if (!x) return '';
    
    const parts = x.toString().split('.');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    
    if (parts.length > 1) {
      return `${integerPart}.${parts[1]}`;
    }
    
    return integerPart;
  };

  const onChangeTextInput = (text) => {
    const numericRegex = /^(\d+)?([.]?\d{0,2})?$/;
    
    if(text === '') {
      setValue(text);
      setData(text);
      if (props.onChange) {
        props.onChange(text);
      }
    } else {
      if(numericRegex.test(text)) {
        setValue(text);
        setData(text);
        if (props.onChange) {
          props.onChange(text);
        }
      }
    }
  }

  const persianWords = convertToPersianWords(data);

  return (
    <View style={styles.container}>
      <TextInput 
        {...props}
        onChange={(data) => onChangeTextInput(data.nativeEvent.text)}
        value={value}
        keyboardType="decimal-pad"
        contentStyle={{ 
          textAlign: languageCodes.includes("fa") ? 'left' : 'right',
        }}
      />
      <View style={styles.overlayContainer}>
        {
          props.format !== false && data && (
            <Text style={styles.commaText}>
              {numberWithComma(data)}
            </Text>
          )
        }
        {
          persianWords && (
            <Text style={styles.persianText}>
              {persianWords}
            </Text>
          )
        }
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
  },
  overlayContainer: {
    position: 'absolute',
    bottom: 4,
    left: 0,
    right: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingHorizontal: 12,
    pointerEvents: 'none',
  },
  commaText: {
    fontSize: 12,
    color: '#555',
  },
  persianText: {
    fontSize: 12,
    color: '#888',
  },
});